import { render, staticRenderFns } from "./NewOrderView.vue?vue&type=template&id=66b2a370&scoped=true&"
import script from "./NewOrderView.vue?vue&type=script&lang=js&"
export * from "./NewOrderView.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderView.vue?vue&type=style&index=0&id=66b2a370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2a370",
  null
  
)

export default component.exports